import { Component, ViewChild, AfterViewInit } from "@angular/core";
import { Config } from "../../core/DefaultConfig";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ComplaintSubType } from "../../core/models/complaint-type.model";
import { DeleteModel } from "../../core/models/dele.model";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { DeleteDialogComponent } from "../../shared/delete-dialog/delete-dialog.component";
import { ComplaintSubtypeAddEditDialogComponent } from "./add-edit-dialog/complaint-subtype-add-edit-dialog.component";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { AlertDialogComponent } from "../../shared/alert-dialog/alert-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AppUrlConstants } from "../../core/constants/AppUrlConstants";
import { ApplicationDataService } from "../../core/services/application-data.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { GenericCrudService } from "../../core/services/generic-crud.service";
import { ComplaintCategoryPipe } from "../../core/pipes/complaint-category.pipe";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from "../../shared/paginator.helper";

@Component({
  selector: "app-complaint-sub-type",
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    TranslateModule,
    ComplaintCategoryPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl(' Complaint types per page') }
  ],
  templateUrl: "./complaint-sub-type.component.html",
})
export class ComplaintSubTypeComponent implements AfterViewInit {
  displayedColumns: string[] = [
    "sr",
    "complaintParentCategoryId",
    "name",
    "legalFramework",
    "complaintResolutionPeriod",
    "whatsappNameEnglish",
    "whatsappNameUrdu",
    "isPublic",
    "action",
  ];
  config = new Config();

  dataSource: MatTableDataSource<ComplaintSubType> = new MatTableDataSource();
  dataList: ComplaintSubType[] = [];
  categoryList: any[] = [];
  deleteModel: DeleteModel = {
    title: "DROP_COMPLAINT_SUB_TYP_TITLE",
    message: "COMPLAINT_SUB_TYPE_DROP_MESSAGE",
    deleteButtonText: "DROP",
    cancelButtonText: "CALCEL",
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    public dialog: MatDialog,
    private crudService: GenericCrudService,
    private appDataService: ApplicationDataService,
    private authService: AuthenticationService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.getByCategorySegment(this.authService.getUserSegment());
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  getByCategorySegment(id: number) {
    this.appDataService.getAllComplaintCategoriesBySegment(id).subscribe({
      next: (res: any) => {
        this.categoryList = res?.data || [];
        this.getBySubCategorySegment(id);
      },
    });
  }
  getBySubCategorySegment(id: number) {
    this.appDataService.getAllComplaintSubCategories().subscribe({
      next: (res: any) => {
        // Update the data source directly to preserve paginator and sort configuration
        this.dataSource.data = res?.data || [];

        // Attach the paginator and sort to the existing data source
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.dataSource.sortingDataAccessor = (item, property) => {
          if (property === 'complaintParentCategoryId') {
            const category = this.categoryList.find(
              (c) => c.complaintCategoryId === (item as any).complaintParentCategoryId
            );
            return category?.name?.toLowerCase() ?? '';
          }
          const value = item[property as keyof typeof item];
          return typeof value === "string" ? value.toLowerCase() : value;
        };
      },
      error: (e) => {
        console.error("Error fetching data:", e);
      },
    });
  }
  add() {
    const dialogRef = this.dialog.open(ComplaintSubtypeAddEditDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  edit(updateRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(ComplaintSubtypeAddEditDialogComponent, {
      data: updateRecord,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  delete(deleteRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel,
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService
          .delete(
            deleteRecord?.complaintCategoryId,
            AppUrlConstants.COMPLAINT_CATEGORY_URL
          )
          .subscribe({
            next: (res: any) => {
              this.dataSource = new MatTableDataSource(res?.data);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
            },
            error: (e) => {
              if (e?.status == 409) {
                if (e?.error?.errors !== null) {
                  for (const property in e.error.errors) {
                    this.openAlert(e.error.errors[property]);
                  }
                } else {
                  this.openAlert(e?.error?.message);
                }
              }
            },
          });
      }
    });
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: "OK",
        },
      },
    });
  }
}
